/**
 * Coldest — Lazyload Rescue
 *
 * The theme's responsive images (img.rimage__image.lazyload) render with no
 * src attribute; lazysizes is expected to substitute {width} in data-src and
 * add .lazyloaded (which resolves the .fade-in opacity:0). If that pipeline
 * stalls (early JS error, plugin failure), images stay blank forever and
 * gallery thumbnails become dead clicks.
 *
 * This script self-heals after page load:
 *  1. Any stalled lazyload image gets a real src (sized to its container)
 *     and the .lazyloaded class so the fade-in resolves.
 *  2. If the product slideshow never initialized (no slick), thumbnail taps
 *     fall back to showing the matching slide instead of navigating to a
 *     raw CDN image.
 */
(function () {
  'use strict';

  if (window.__coldestLazyloadRescue) return;
  window.__coldestLazyloadRescue = true;

  var WIDTHS = [180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

  function pickWidth(img) {
    var rendered = img.getBoundingClientRect().width;
    if (!rendered && img.parentElement) {
      rendered = img.parentElement.getBoundingClientRect().width;
    }
    var target = (rendered || 720) * Math.min(window.devicePixelRatio || 1, 2);
    for (var i = 0; i < WIDTHS.length; i++) {
      if (WIDTHS[i] >= target) return WIDTHS[i];
    }
    return WIDTHS[WIDTHS.length - 1];
  }

  function rescueImage(img) {
    if (img.classList.contains('lazyloaded') || img.getAttribute('src')) return;
    var dataSrc = img.getAttribute('data-src');
    if (!dataSrc || dataSrc.indexOf('{width}') === -1) return;
    img.src = dataSrc.replace('{width}', pickWidth(img));
    img.classList.add('lazyloaded');
  }

  function rescueAll() {
    document
      .querySelectorAll('img.rimage__image.lazyload:not(.lazyloaded):not([src])')
      .forEach(rescueImage);
  }

  /* Thumbnail fallback: only takes over when slick never initialized,
     otherwise the theme's own gallery handlers stay in charge. */
  function bindThumbnailFallback() {
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('.gallery .thumbnails .thumbnail');
      if (!thumb) return;

      var gallery = thumb.closest('.gallery');
      var slideshow = gallery && gallery.querySelector('.product-slideshow');
      if (!slideshow || slideshow.classList.contains('slick-initialized')) return;

      e.preventDefault();
      var mediaId = thumb.getAttribute('data-media-id');
      if (!mediaId) return;

      slideshow.querySelectorAll('.slide').forEach(function (slide) {
        var isTarget = slide.getAttribute('data-media-id') === mediaId;
        slide.style.display = isTarget ? '' : 'none';
        if (isTarget) {
          slide.querySelectorAll('img.rimage__image.lazyload').forEach(rescueImage);
        }
      });
    });
  }

  function start() {
    bindThumbnailFallback();
    /* Give lazysizes a fair chance first, then heal whatever it missed. */
    setTimeout(rescueAll, 1500);
    setTimeout(rescueAll, 4000);
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }
})();
